import useInterfaceConfig from "@hooks/useInterfaceConfig";
import { useEffect } from "react";

const LegalarioScript = () => {
  const interfaceConfig = useInterfaceConfig();

  useEffect(() => {
    const loadScript = () => {
      if (!document.getElementById("legalario-js")) {
        const script_url =
          interfaceConfig.firma?.legalario_config?.custom_url_sdk || import.meta.env.VITE_LEGALARIO_SDK_URL;
        const script = document.createElement("script");
        script.id = "legalario-js";
        script.src = script_url;
        document.head.appendChild(script);
      }
    };
    loadScript();
  }, [interfaceConfig.firma?.legalario_config?.custom_url_sdk]);

  return null;
};

export default LegalarioScript;
